<template>
	<footer>
		<div class="fotter-area d-dark-bg">
			<div class="footer__top pt-80 pb-15">
				<div class="container">
					<div class="row">
						<div class="col-xl-5 col-lg-4 order-last-md d-none">
							<div class="row">
								<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
									<div class="footer__widget d-none">
										<div class="footer__widget-title">
											<h4>Customer Care</h4>
										</div>
										<div class="footer__widget-content">
											<div class="footer__link">
												<ul>
													<li><a href="faq">New Customers</a></li>
													<li><a href="faq">How to use Account</a></li>
													<li><a href="faq">Placing an Order</a></li>
													<li><a href="faq">Payment Methods</a></li>
													<li>
														<a href="faq">Delivery &amp; Dispatch</a>
													</li>
													<li><a href="faq">Problems with Order</a></li>
												</ul>
											</div>
										</div>
									</div>
								</div>
								<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
									<div class="footer__widget d-none">
										<div class="footer__widget-title">
											<h4>Customer Service</h4>
										</div>
										<div class="footer__widget-content">
											<div class="footer__link">
												<ul>
													<li><a href="faq">Help Center</a></li>
													<li><a href="faq">Contact Us</a></li>
													<li><a href="faq">Report Abuse</a></li>
													<li><a href="faq">Submit a Dispute</a></li>
													<li><a href="faq">Policies &amp; Rules</a></li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-12 col-lg-12 order-first-md text-center">
							<div class="footer__top-left">
								<div class="row">
									<div class="col-xl-7 col-lg-6 col-md-6 col-sm-6">
										<div class="row">
											<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 d-none">
												<div class="footer__widget">
													<div class="footer__widget-title">
														<h4>My Account</h4>
													</div>
													<div class="footer__widget-content">
														<div class="footer__link">
															<ul>
																<li><a href="faq">Product Support</a></li>
																<li><a href="checkout">Checkout</a></li>
																<li><a href="cart">Shopping Cart</a></li>
																<li><a href="wishlist">Wishlist</a></li>
																<li>
																	<a href="faq">Terms &amp; Conditions &amp;</a>
																</li>
																<li><a href="faq">Redeem Voucher</a></li>
															</ul>
														</div>
													</div>
												</div>
											</div>
											<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
												<div class="footer__widget">
													<div class="footer__widget-title">
														<h4>Quick Links</h4>
													</div>
													<div class="footer__widget-content">
														<div class="footer__link">
															<ul>
																<li>
																	<a href="/about">회사 소개</a>
																</li>
																<li>
																	<a href="/contact">회사 위치</a>
																</li>
																<!-- <li>
																	<a href="/contact">문의 하기</a>
																</li> -->
																<li><a href="/faq">FAQ</a></li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 text-start">
										<div class="footer__widget">
											<div class="footer__widget-title mb-20">
												<h4>상점 정보</h4>
											</div>
											<div class="footer__widget-content">
												<p class="footer-text mb-35">
													우리의 사명 선언문은 예외 없이 전자 산업에서 사용할 수
													있는 절대적으로 최고의 고객 경험을 제공하는 것입니다.
												</p>
												<div
													class="footer__hotline d-flex align-items-center mb-10"
												>
													<div class="icon mr-15">
														<i class="fal fa-headset"></i>
													</div>
													<div class="text">
														<h4>
															질문이 있습니까? 연중무휴 24시간 전화주세요!
														</h4>
														<span
															><a href="tel:02-2269-3134">02-2269-3134</a></span
														>
													</div>
												</div>
												<div class="footer__info d-none">
													<ul>
														<li>
															<span
																>Add:
																<a
																	target="_blank"
																	href="https://goo.gl/maps/c82DDZ8ALvL878Bv8"
																	>Walls Street 68, Mahattan, New York, USA</a
																></span
															>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer__bottom">
				<div class="container">
					<div class="footer__bottom-content pt-25 pb-45">
						<div class="row">
							<div class="col-xl-12">
								<div class="footer__links text-center mb-25 d-none">
									<p>
										<a href="faq">Online Shopping</a>
										<a href="faq">Promotions</a>
										<a href="faq">My Orders</a>
										<a href="faq">Help</a>
										<a href="faq">Customer Service</a>
										<a href="faq">Support</a>
										<a href="faq">Most Populars</a>
										<a href="faq">New Arrivals</a>
										<a href="faq">Special Products </a>
										<a href="faq">Manufacturers</a>
										<br />
										<a href="faq">Garden Equipments</a>
										<a href="faq">Powers And Hand Tools </a>
										<a href="faq">Utensil &amp; Gadget </a>
										<a href="faq">Printers</a>
										<a href="faq">Projectors</a>
										<a href="faq">Scanners</a>
										<a href="faq">Store</a>
										<a href="faq">Business</a>
									</p>
								</div>
								<div class="payment-image text-center mb-25 d-none">
									<a href="contact"
										><img src="/assets/img/payment/payment.png" alt=""
									/></a>
								</div>
								<div class="copy-right-area text-center">
									<p>
										법인명 : (주)해오름커뮤니케이션즈 | 대표자 : 김무현 |
										사업자등록번호 : 201-81-71107 주소 : (08377) 서울특별시
										구로구 디지털로 33길 12(구로동) 우림이비지센터2차 212호
										Tel.02-2269-3134 | Fax.02-2263-1080 | 이메일 :
										help@horm.co.kr Copyright (C) 2014 HaeorumCommunications
										CO.,LTD. All rights reserved.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {};
</script>

<style></style>
